<template lang="pug">
artwork-slideshow(
    v-show="active"
    ref="slideshow"
    v-bind:items="items"
    v-bind:index="index"
    v-bind:active="active"
    v-on:next-page="onNextPage"
    v-on:prev-page="onPrevPage"
    v-on:close="onClose")

</template>

<script>
import ArtworkSlideshow from '@/components/Artwork/Slideshow';

/**
 * This component controls the Artwork/Slideshow, which uses PhotoSwipe.
 * There should be only one instance of it on the page, so this control
 * component is added in the main App template and items displayed by calling
 * this on the global event bus.
 */
export default {
    name: 'slideshow-ctrl',

    components: {
        ArtworkSlideshow
    },

    data: function () {
        return {
            items: null,
            index: 0,
            totalCount: 0,
            active: false
        };
    },

    mounted: function () {
        this.$eventBus.$on('open-slideshow', this.onOpen);
    },

    beforeDestroy: function () {
        this.$eventBus.$off('open-slideshow', this.onOpen);
    },

    methods: {
        onOpen: function (items, index, totalCount, uid) {
            this.items = items;
            this.index = index || 0;
            this.totalCount = totalCount;
            this.stackUid = uid;
            this.active = true;
        },

        onClose: function () {
            this.active = false;
            this.$nextTick(() => {
                this.items = [];
                this.index = 0;
                this.totalCount = 0;
            });
        },

        onNextPage: function () {
            this.$eventBus.$emit('stack-next-page', this.stackUid, 'slideshow');
        },

        onPrevPage: function () {
            this.$eventBus.$emit('stack-prev-page', this.stackUid, 'slideshow');
        }
    }
};
</script>
